export default [
    {
        path: '/', redirect: '/order'
    },
    {
        path: '/home',
        meta: {
            hidden: true,
            title: ''
        },
        component: () => import('@/views/app/home')
    },
    {
        path: '/order',
        meta: {
            hidden: true,
            title: ''
        },
        component: () => import('@/views/app/order')
    },
    {
        path: '/login',
        meta: {
            hidden: true,
            title: ''
        },
        component: () => import('@/views/app/login')
    },
    {
        path: '/404',
        meta: {
            hidden: true,
            title: ''
        },
        component: () => import('@/views/404')
    },
    {
        path: '*', redirect: '/404'
    }
]


// WEBPACK FOOTER //
// ./src/router/routes.js